import { Component, ViewEncapsulation, Input, HostBinding, SimpleChanges, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'tidy-photo-note',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./photo-note.component.scss'],
    template: `
    <tidy-image [tidyImageViewer]="srcWithUniqueQuery" [width]="imageWidth" [src]="srcWithUniqueQuery" [loading]="'eager'" class="full-width" (imageDidLoad)="onImageLoad()"></tidy-image>
    @if (caption) {
      <span class="photo-caption">{{caption}}</span>
    }
    `,
    standalone: false
})
export class PhotoNoteComponent implements OnInit, OnChanges {
  @Input() caption: string;
  @Input() src: string;
  @Input() isFullWidth = false;
  @Output() imagesLoaded = new EventEmitter<void>();
  @HostBinding('class.full-width') setFullWidth = false;
  imageWidth: string;
  srcWithUniqueQuery: string;

  ngOnInit() {
    this.setFullWidth = this.isFullWidth;
    this.updateSrcWithUniqueQuery();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.src) {
      this.updateSrcWithUniqueQuery();
    }
  }

  onImageLoad() {
    this.imagesLoaded.emit();
  }

  private updateSrcWithUniqueQuery() {
    const isBase64 = this.src.includes('data:image');
    if (isBase64) {
      this.srcWithUniqueQuery = this.src;
      return;
    }
    const timestamp = new Date().getTime();
    this.srcWithUniqueQuery = `${this.src}?v=${timestamp}`;
  }

  public setImageWidth(width: string) {
    this.imageWidth = width
  }
}
